"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4276],{

/***/ 5324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39112);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  border: 1px solid ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-c22a9310-0"
}).withConfig({
    componentId: "sc-39f22014-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 39112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 44482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(55027);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeader.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  padding-bottom: 32px;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Outer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-1b6d10b3-0"
})(_templateObject(), function(param) {
    var theme = param.theme, background = param.background;
    return background || theme.colors.gradients.bubblegum;
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-1b6d10b3-1"
})(_templateObject1());
var PageHeader = function(_param) /*#__PURE__*/ {
    var background = _param.background, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "background",
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Outer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: background
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {
            children: children
        })
    }));
};
/* harmony default export */ var PageHeader_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/components/PageHeader/index.ts




/***/ }),

/***/ 71228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useCallWithGasPrice; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var state_user_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68605);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69077);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69330);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93293);
/* harmony import */ var _useActiveChainId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62349);









function useCallWithGasPrice() {
    var gasPrice = (0,state_user_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useGasPrice */ .Fh)();
    var chainId = (0,_useActiveChainId__WEBPACK_IMPORTED_MODULE_5__/* .useActiveChainId */ .gi)().chainId;
    var ref = (0,wagmi__WEBPACK_IMPORTED_MODULE_6__/* .useWalletClient */ .py)(), walletClient = ref.data;
    /**
   * Perform a contract call with a gas price returned from useGasPrice
   * @param contract Used to perform the call
   * @param methodName The name of the method called
   * @param methodArgs An array of arguments to pass to the method
   * @param overrides An overrides object to pass to the method. gasPrice passed in here will take priority over the price returned by useGasPrice
   * @returns https://docs.ethers.io/v5/api/providers/types/#providers-TransactionReceipt
   */ // 
    var callWithGasPriceWithSimulate = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(contract, methodName, methodArgs, overrides) {
            var gas, res, hash;
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,utils_wagmi__WEBPACK_IMPORTED_MODULE_3__/* .publicClient */ .z2)({
                            chainId: chainId
                        }).estimateContractGas((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            abi: contract.abi,
                            address: contract.address,
                            account: walletClient.account,
                            functionName: methodName,
                            args: methodArgs,
                            gasPrice: gasPrice,
                            value: 0
                        }, overrides));
                    case 2:
                        gas = _ctx.sent;
                        _ctx.next = 5;
                        return walletClient.writeContract((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            abi: contract.abi,
                            address: contract.address,
                            account: walletClient.account,
                            functionName: methodName,
                            args: methodArgs,
                            gasPrice: gasPrice,
                            gas: (0,utils__WEBPACK_IMPORTED_MODULE_4__/* .calculateGasMargin */ .yC)(gas),
                            value: 0n
                        }, overrides));
                    case 5:
                        res = _ctx.sent;
                        hash = res;
                        return _ctx.abrupt("return", {
                            hash: hash
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(contract, methodName, methodArgs, overrides) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chainId,
        gasPrice,
        walletClient
    ]);
    return {
        callWithGasPrice: callWithGasPriceWithSimulate
    };
}


/***/ }),

/***/ 57164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCatchTxError; },
  "n": function() { return /* binding */ parseError; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/base.js
var base = __webpack_require__(69977);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/rpc.js
var rpc = __webpack_require__(42455);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/config/chains.ts
var chains = __webpack_require__(38512);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/clients/createPublicClient.js + 41 modules
var createPublicClient = __webpack_require__(6146);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/clients/transports/http.js
var http = __webpack_require__(27436);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 7 modules
var chunk_LAFZBYO7 = __webpack_require__(40032);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(62349);
;// CONCATENATED MODULE: ./src/hooks/usePublicNodeWaitForTransaction.ts










var viemClientsPublicNodes = chains/* CHAINS.reduce */.zG.reduce(function(prev, cur) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, cur.id, (0,createPublicClient/* createPublicClient */.v)({
        chain: cur,
        transport: (0,http/* http */.d)(cur.rpcUrls.public.http[0], {
            timeout: 15000
        }),
        batch: {
            multicall: {
                batchSize: 1024 * 200
            }
        }
    })));
}, {});
function usePublicNodeWaitForTransaction() {
    var chainId = (0,useActiveChainId/* useActiveChainId */.gi)().chainId;
    var waitForTransaction_ = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(opts) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!viemClientsPublicNodes[chainId]) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", viemClientsPublicNodes[chainId].waitForTransactionReceipt(opts));
                    case 2:
                        return _ctx.abrupt("return", (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, opts), {
                            chainId: chainId
                        })));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(opts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chainId
    ]);
    return {
        waitForTransaction: waitForTransaction_
    };
}

;// CONCATENATED MODULE: ./src/hooks/useCatchTxError.tsx
/* provided dependency */ var process = __webpack_require__(34155);











/// only show corrected parsed viem error
function parseError(err) {
    if ((0,_instanceof/* default */.Z)(err, base/* BaseError */.G)) {
        return err;
    }
    if (typeof err === "string") {
        return new rpc/* UnknownRpcError */.ir(new Error(err));
    }
    if ((0,_instanceof/* default */.Z)(err, Error)) {
        return new rpc/* UnknownRpcError */.ir(err);
    }
    return null;
}
// -32000 is insufficient funds for gas * price + value
var isGasEstimationError = function(err) {
    var ref;
    return (err === null || err === void 0 ? void 0 : (ref = err.data) === null || ref === void 0 ? void 0 : ref.code) === -32000;
};
var notPreview = process.env.NEXT_PUBLIC_VERCEL_ENV !== "preview";
function useCatchTxError() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useToast/* default */.Z)(), toastError = ref.toastError, toastSuccess = ref.toastSuccess;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var waitForTransaction = usePublicNodeWaitForTransaction().waitForTransaction;
    var ref2 = (0,react.useState)(false), txResponseLoading = ref2[0], setTxResponseLoading = ref2[1];
    var handleNormalError = (0,react.useCallback)(function(error) {
        (0,sentry/* logError */.H)(error);
        var err = parseError(error);
        if (err) {
            toastError(t("Error"), t("Transaction failed with error: %reason%", {
                reason: notPreview ? error.shortMessage || error.message : error.message
            }));
        } else {
            toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
        }
    }, [
        t,
        toastError
    ]);
    var handleTxError = (0,react.useCallback)(function(error, hash) {
        (0,sentry/* logError */.H)(error);
        var err = parseError(error);
        toastError(t("Failed"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
            txHash: hash,
            children: err ? t("Transaction failed with error: %reason%", {
                reason: notPreview ? err.shortMessage || err.message : err.message
            }) : t("Transaction failed. For detailed error message:")
        }));
    }, [
        t,
        toastError
    ]);
    var fetchWithCatchTxError = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callTx) {
            var tx, hash, receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tx = null;
                        _ctx.prev = 1;
                        setLoading(true);
                        _ctx.next = 5;
                        return callTx();
                    case 5:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _ctx.sent;
                        hash = typeof tx === "string" ? tx : tx.hash;
                        toastSuccess("".concat(t("Transaction Submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: hash
                        }));
                        _ctx.next = 10;
                        return waitForTransaction({
                            hash: hash
                        });
                    case 10:
                        receipt = _ctx.sent;
                        return _ctx.abrupt("return", receipt);
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,sentry/* isUserRejected */.Z)(_ctx.t0)) {
                            if (!tx) {
                                handleNormalError(_ctx.t0);
                            } else {
                                handleTxError(_ctx.t0, typeof tx === "string" ? tx : tx.hash);
                            }
                        }
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                        return _ctx.abrupt("return", null);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14,
                    17,
                    20
                ]
            ]);
        }));
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastSuccess,
        t,
        waitForTransaction,
        handleNormalError,
        handleTxError
    ]);
    var fetchTxResponse = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callTx) {
            var tx, hash;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tx = null;
                        _ctx.prev = 1;
                        setTxResponseLoading(true);
                        _ctx.next = 5;
                        return callTx();
                    case 5:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _ctx.sent;
                        hash = typeof tx === "string" ? tx : tx.hash;
                        toastSuccess("".concat(t("Transaction Submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: hash
                        }));
                        return _ctx.abrupt("return", {
                            hash: hash
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,sentry/* isUserRejected */.Z)(_ctx.t0)) {
                            if (!tx) {
                                handleNormalError(_ctx.t0);
                            } else {
                                handleTxError(_ctx.t0, typeof tx === "string" ? tx : tx.hash);
                            }
                        }
                    case 14:
                        _ctx.prev = 14;
                        setTxResponseLoading(false);
                        return _ctx.finish(14);
                    case 17:
                        return _ctx.abrupt("return", null);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastSuccess,
        t,
        handleNormalError,
        handleTxError
    ]);
    return {
        fetchWithCatchTxError: fetchWithCatchTxError,
        fetchTxResponse: fetchTxResponse,
        loading: loading,
        txResponseLoading: txResponseLoading
    };
};


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92876);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42455);



var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var possibleRejectMessage = [
    "Cancelled by User",
    "cancel",
    "Transaction was rejected"
];
var isUserRejected = function(err) {
    // provider user rejected error code
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(err, viem__WEBPACK_IMPORTED_MODULE_1__/* .UserRejectedRequestError */ .ab)) {
        return true;
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(err, viem__WEBPACK_IMPORTED_MODULE_1__/* .UnknownRpcError */ .ir)) {
        // fallback for some wallets that don't follow EIP 1193, trust, safe
        if (possibleRejectMessage.some(function(msg) {
            var ref;
            return (ref = err.details) === null || ref === void 0 ? void 0 : ref.includes(msg);
        })) {
            return true;
        }
    }
    // fallback for raw rpc error code
    if (typeof err === "object") {
        if ("code" in err && (err.code === 4001 || err.code === "ACTION_REJECTED") || "cause" in err && "code" in err.cause && err.cause.code === 4001) {
            return true;
        }
        if ("cause" in err) {
            return isUserRejected(err.cause);
        }
    }
    return false;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ }),

/***/ 6958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ TokenpadProvider; },
/* harmony export */   "ZR": function() { return /* binding */ useConfig; }
/* harmony export */ });
/* unused harmony export TokenpadContext */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var config_abi_tokenFactory_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83504);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64011);
/* harmony import */ var utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96273);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69330);
/* harmony import */ var utils_bigNumber__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35128);










var TokenpadContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(null);
function useConfig() {
    return (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(TokenpadContext);
}
function TokenpadProvider(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(utils_bigNumber__WEBPACK_IMPORTED_MODULE_8__/* .BIG_ZERO */ .HW), launchFee = ref[0], setLaunchFee = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), ownedTokens = ref1[0], setOwnedTokens = ref1[1];
    var ref2 = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), account = ref2.account, chainId = ref2.chainId;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var client, tokenFactoryAddress, launchFeeResult;
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        client = (0,utils_wagmi__WEBPACK_IMPORTED_MODULE_7__/* .publicClient */ .z2)({
                            chainId: chainId
                        });
                        tokenFactoryAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getTokenFactoryAddress */ .mL)(chainId);
                        _ctx.next = 4;
                        return client.readContract({
                            abi: config_abi_tokenFactory_json__WEBPACK_IMPORTED_MODULE_4__,
                            address: tokenFactoryAddress,
                            functionName: "launchFee",
                            args: []
                        });
                    case 4:
                        launchFeeResult = _ctx.sent;
                        setLaunchFee(new (bignumber_js__WEBPACK_IMPORTED_MODULE_3___default())(launchFeeResult.toString()));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        chainId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (account && chainId) (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var client, tokenFactoryAddress, tokenCountResult, tokenAddressesResult;
            return _root_candy_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        client = (0,utils_wagmi__WEBPACK_IMPORTED_MODULE_7__/* .publicClient */ .z2)({
                            chainId: chainId
                        });
                        tokenFactoryAddress = (0,utils_addressHelpers__WEBPACK_IMPORTED_MODULE_6__/* .getTokenFactoryAddress */ .mL)(chainId);
                        _ctx.next = 4;
                        return client.readContract({
                            abi: config_abi_tokenFactory_json__WEBPACK_IMPORTED_MODULE_4__,
                            address: tokenFactoryAddress,
                            functionName: "ownedTokenCount",
                            args: [
                                account
                            ]
                        });
                    case 4:
                        tokenCountResult = _ctx.sent;
                        _ctx.next = 7;
                        return client.readContract({
                            abi: config_abi_tokenFactory_json__WEBPACK_IMPORTED_MODULE_4__,
                            address: tokenFactoryAddress,
                            functionName: "ownedTokens",
                            args: [
                                account,
                                0,
                                tokenCountResult
                            ]
                        });
                    case 7:
                        tokenAddressesResult = _ctx.sent;
                        // @ts-ignore
                        setOwnedTokens(tokenAddressesResult);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
        else setOwnedTokens([]);
    }, [
        account,
        chainId
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TokenpadContext.Provider, {
        value: {
            launchFee: launchFee,
            ownedTokens: ownedTokens
        },
        children: children
    });
};


/***/ }),

/***/ 410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TokenpadLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50156);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39320);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4318);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(59750);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95963);
/* harmony import */ var components_Layout_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55027);
/* harmony import */ var components_Layout_Page__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83559);
/* harmony import */ var components_NextLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53629);
/* harmony import */ var components_PageHeader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44482);
/* harmony import */ var _contexts_TokenpadContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6958);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8dece5f8-0"
})(_templateObject());
var TokenpadTabButtons = function() {
    /* eslint no-restricted-globals: ["error", "event", "fdescribe"] */ var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isExact = router.route === "/launchpad/tokenpad";
    var tabIndex = 0;
    if (isExact) {
        tabIndex = 0;
    } else {
        tabIndex = 1;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            activeIndex: tabIndex,
            scale: "sm",
            variant: "subtle",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    as: components_NextLink__WEBPACK_IMPORTED_MODULE_7__/* .NextLinkFromReactRouter */ .a,
                    to: "/launchpad/tokenpad",
                    children: "Create"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    as: components_NextLink__WEBPACK_IMPORTED_MODULE_7__/* .NextLinkFromReactRouter */ .a,
                    to: "/launchpad/tokenpad/manage",
                    children: "Manage"
                })
            ]
        })
    });
};
var TokenpadLayout = function(param) {
    var children = param.children;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_contexts_TokenpadContext__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_PageHeader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        flex: "1",
                        flexDirection: "column",
                        mr: [
                            "8px",
                            0
                        ],
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                as: "h1",
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Tokenpad")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                scale: "lg",
                                color: "text",
                                children: t("Create new token with your own tokenomics.")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Page__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TokenpadTabButtons, {}),
                        children
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 50301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PJ": function() { return /* binding */ MAX_TX_AMOUNT_MIN_LIMIT; },
/* harmony export */   "R$": function() { return /* binding */ MAX_HOLD_AMOUNT_MIN_LIMIT; },
/* harmony export */   "lE": function() { return /* binding */ MAX_TAX; }
/* harmony export */ });
var MAX_TAX = 30;
var MAX_TX_AMOUNT_MIN_LIMIT = 0.01;
var MAX_HOLD_AMOUNT_MIN_LIMIT = 0.02;


/***/ })

}]);